import { handleActions } from '../../helpers/immer';
import * as action from '../../actions/Tasks';

const initialValue = {
  loading: true,
  claiming: false,
  // A completed response (including failures) stops automatic retries.
  loaded: false,
  data: null,
};
export const tasks = handleActions(
  {
    [action.getTasksData]: (draft, { payload }) => {
      draft.data = payload || null;
      draft.loaded = true;
    },
    [action.getTasksListLoading]: (draft, { payload }) => {
      draft.loading = payload;
    },
    [action.claimTasksRewardLoading]: (draft, { payload }) => {
      draft.claiming = payload;
    },
  },
  initialValue
);
